<!-- 编辑商品清单-->
<template>
    <div class="business-content-main goodsMerge" v-loading="saving">
        <div>
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true"></breadcrumb>
            </div>
            <div class="section-title">
                <div class="flex">
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" @click="save">保存主附商品设置</el-button>
                </div>
            </div>
        </div>

        <div id="infinite-list">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: false }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :row-style="setRowStyle"
                highlight-current-row
                show-overflow="tooltip"
                :row-class-name="tableRowClassName"
                @row-click="rowClick"
                @cell-click="cellClick"
            >
                <ux-table-column field="APCode" title="主商品编码" min-width="50" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.GoodsId)" />
                            <span>{{ row.APCode ? row.APCode : '请点击选中主商品编码' }}</span>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="kcode"
                            :loading="codeForm.loading"
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex, 'keep')"
                            @visible-change="apCodeVisibleChange($event)"
                            @keyup.enter.native="addItem(true)"
                            :remote-method="
                                query => {
                                    searchCode(query, scope.rowIndex);
                                }
                            "
                            style="width: 100%"
                            popper-class="el-select-style-gray"
                            v-select-scroll-more="searchCodeLoad"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="optionItem.APCode"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name in-one-line">
                                        {{ optionItem.AutoSerise }}
                                    </div>
                                    <div class="project-Name">
                                        {{ optionItem.GoodCode }}
                                    </div>
                                </div>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" title="主商品称" min-width="50" resizable>
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.GoodName }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSerise" title="主商品车型" min-width="50" resizable>
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.AutoSerise }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Inventory" title="主商品库存" min-width="50">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.Inventory }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="VAPCode" title="附属商品编码" min-width="50" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.VAPCode }]">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.VGoodsId)" />
                            <span>{{ row.VAPCode ? row.VAPCode : '请点击选中附属编码' }}</span>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="dcode"
                            :loading="codeForm_del.loading"
                            default-first-option
                            size="small"
                            v-model="scope.row.VAPCode"
                            value-key="APCode"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex, 'del')"
                            @visible-change="apCodeVisibleChange_del($event)"
                            @keyup.enter.native="addItem(true)"
                            :remote-method="
                                query => {
                                    searchCode_del(query, scope.rowIndex);
                                }
                            "
                            style="width: 100%"
                            popper-class="el-select-style-gray"
                            v-select-scroll-more="searchCodeLoad_del"
                        >
                            <el-option
                                v-for="optionItem in codeList_del"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="optionItem.APCode"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name in-one-line">
                                        {{ optionItem.AutoSerise }}
                                    </div>
                                    <div class="project-Name">
                                        {{ optionItem.GoodCode }}
                                    </div>
                                </div>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="VGoodName" title="附属商品名称" min-width="50" resizable>
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.VGoodName }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="VAutoSerise" title="附属商品车型" min-width="50" resizable>
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.VAutoSerise }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="VInventory" title="附属商品库存" min-width="50">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.VInventory }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" min-width="150" resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <i v-if="showIconDelete(row)" class="el-icon-delete" title="移除" @click="delItem(rowIndex)"></i>
                            <i v-if="showIconAdd(rowIndex)" class="el-icon-plus" title="添加" @click="addItem(true)"></i>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        APMsg,
        breadcrumb,
    },
    data() {
        return {
            EntpTempGoodsIdEdit: '',
            APMsgVisible: false,
            saving: false,
            loading: false,
            codeList: [],
            codeList_del: [],
            dataList: [],
            infiniteListHeight: 0,
            dataindex: 0,
            currentRow: {},
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: '',
                loading: false
            },
            codeForm_del: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: '',
                loading: false
            },
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        let that = this;
        document.addEventListener('keydown', that.handleKeyEvent);
    },
    mounted() {
        this.init();
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);
        window.onresize = () => {
            this.resetHeight();
        };
        setTimeout(() => {
            this.resetHeight();
        }, 0);
    },
    computed: {
        // 列表高度
        infiniteTableHeight() {
            let bottomHeight = 38;
            return this.infiniteListHeight - bottomHeight;
        },
        showIconDelete() {
            return function(row) {
                return this.dataList.length !== 1;
            };
        },
        showIconAdd() {
            return function(rowIndex) {
                return rowIndex + 1 === this.dataList.length;
            };
        },
    },
    methods: {
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        init(){
            this.dataList = [];
            this.dataList.push({
                Inventory: 0, //商品总数量
                GoodsId: '',
                APCode: '',
                GoodName: '',
                AutoSerise:'',
                VGoodsId: '',
                VAPCode: '',
                VGoodName: '',
                VAutoSerise: '',
                VInventory: 0,
            });
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
        },
        // 添加一行
        addItem() {
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写主配件编码');
                    return;
                }
                if (!_dataList[i].VAPCode) {
                    this.$util.warningMsg('请填写附属配件编码');
                    return;
                }
            }

            this.codeForm.key = '';
            this.codeForm.Page = 1;
            this.codeForm.Limit = 10;
            this.codeForm.stopLoad = false;

            var data =  _dataList[this.dataList.length-1];

            this.dataList.push({
                Inventory: data.Inventory,
                GoodsId: data.GoodsId,
                APCode: data.APCode,
                GoodName: data.GoodName,
                AutoSerise:data.AutoSerise,
                VGoodsId: '',///副商品
                VAPCode: '',
                VGoodName: '',
                VAutoSerise: '',
                VInventory: 0,
            });

        },
        // 编码改变
        codeChange(value, index, obj) {
            let that = this;
            if (!value) {
                return;
            }

            if (obj == 'keep') {
                let _list = this.codeList;
                let item = _list.find(v => v.APCode == value);
                if (item) {
                    var same = that.dataList.find(v => v.VAPCode == value);
                    if (same) {
                        that.dataList[index].APCode = '';
                        that.$util.warningMsg('商品已经在当前附属列表上了');
                        return;
                    }
                    that.dataList[index].APCode = item.APCode;
                    that.dataList[index].GoodsId = item.EntpTempGoodsId;
                    that.dataList[index].GoodName = item.GoodName;
                    that.dataList[index].AutoSerise = item.AutoSerise;
                    that.dataList[index].Inventory = item.Inventory;
                    that.$refs[`dcode`].focus();
                }
                return;
            }

            if (obj == 'del') {
                let _list = this.codeList_del;
                let item = _list.find(v => v.APCode == value);
                if (item) {
                    var same1 = that.dataList.find(v => v.GoodsId == item.EntpTempGoodsId || v.VGoodsId == item.EntpTempGoodsId );
                    if (same1) {
                        that.dataList[index].VAPCode = '';
                        that.$util.warningMsg('商品已经在当前列表上了');
                        return;
                    }
                    that.dataList[index].VAPCode = item.APCode;
                    that.dataList[index].VGoodsId = item.EntpTempGoodsId;
                    that.dataList[index].VGoodName = item.GoodName;
                    that.dataList[index].VAutoSerise = item.AutoSerise;
                    that.dataList[index].VInventory = item.Inventory;
                    that.codeList_del = [];
                    return;
                }
            }
            return;
        },

        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.codeList.length == 0) that.searchCode('');
            }
        },

        // 搜索汽配编码
        searchCode(key, index) {
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeForm.rowIndex = index;
                this.codeList = [];
            }
            if (this.codeForm.stopLoad) return;
            this.codeForm.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForMergeOrder',
                    data: {
                        APCode: this.codeForm.key,
                        Page: this.codeForm.Page,
                        Limit: this.codeForm.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    let that = this;
                    this.codeForm.loading = false;
                    if (!res.data) {
                        if (this.codeForm.Page == 1 && that.codeForm.key) {
                            this.codeList = [];
                        }
                        return;
                    }
                    this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
                    this.codeList = this.$util.uniqueArr(this.codeList, res.data);
                });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.codeForm.loading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },

        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange_del(event) {
            let that = this;
            if (event) {
                if (that.codeList_del.length == 0) that.searchCode_del('');
            }
        },

        // 搜索汽配编码
        searchCode_del(key, index) {
            if (![undefined].includes(key)) {
                this.codeForm_del.Page = 1;
                this.codeForm_del.stopLoad = false;
                this.codeForm_del.key = key;
                this.codeForm_del.rowIndex = index;
                this.codeList_del = [];
            }
            if (this.codeForm_del.stopLoad) return;
            this.codeForm_del.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForMergeOrder',
                    data: {
                        APCode: this.codeForm_del.key,
                        Page: this.codeForm_del.Page,
                        Limit: this.codeForm_del.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    let that = this;
                    this.codeForm_del.loading = false;
                    if (!res.data) {
                        if (this.codeForm_del.Page == 1 && that.codeForm_del.key) {
                            this.codeList_del = [];
                        }
                        return;
                    }
                    this.codeForm_del.stopLoad = res.data.length < this.codeForm_del.Limit;
                    this.codeList_del = this.$util.uniqueArr(this.codeList_del, res.data);
                });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad_del() {
            if (!this.codeForm_del.loading) {
                this.codeForm_del.Page += 1;
                this.searchCode_del();
            }
        },

        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = this.dataList.filter(f => f.VGoodsId === row.VGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },

        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
            this.currentRow = row;
        },
        cellClick(row, column, cell, event) {
            if (column.property === 'APCode') {
                setTimeout(() => {
                    this.$refs[`kcode`].focus();
                }, 200);
                return;
            }
        },
        goodsViceSetsList(){
            this.$router.push(`/inventoryManage/goods/goodsViceSetsList`);
        },
        save(){
            var goodsList = [];
            if(this.dataList.length == 0){
                this.$util.warningMsg("请选择数据");
                return false;
            }
            for(var i = 0; i < this.dataList.length;i++){
                if(this.dataList[i].APCode == this.dataList[i].VAPCode){
                    this.$util.warningMsg("第"+ (i+1) + "列的主商品和附属商品不能相同！");
                    return false;
                }
                if(this.dataList[i].GoodsId && this.dataList[i].VGoodsId){
                    goodsList.push({
                            GoodsId : this.dataList[i].GoodsId,
                            APCode : this.dataList[i].APCode,
                            VGoodsId : this.dataList[i].VGoodsId,
                            VAPCode : this.dataList[i].VAPCode
                        }
                    );
                }else{
                    this.$util.warningMsg("第"+ (i+1) + "列的附属商品未填写！");
                    return false;
                }
            }
            this.saving = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/SaveViceGoodsSetsList',
                    data: { GoodsList : goodsList},
                })
                .then(res => {
                    var that = this;
                    if (res.errcode == 0) {
                        that.$util.successMsg(res.errmsg);
                        that.goodsViceSetsList();
                    }
                    else
                        that.$util.errorMsg("保存失败");

                }).finally(() => {
                    this.saving = false;
                });
        },
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            //下键
            if (key == 40) {
                e.preventDefault();
                if (that.dataindex != that.dataList.length - 1) {
                    if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                        that.dataindex++;
                    } else that.dataindex = 0;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.infiniteTable) {
                            that.currentRow = that.$refs.infiniteTable.data[index];
                            that.$refs.infiniteTable.setCurrentRow(that.$refs.infiniteTable.data[index]);
                        }
                    });
                }

                return;
            }
            //上键
            if (key == 38) {
                e.preventDefault();
                if (that.dataindex != 0) {
                    that.dataindex--;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.infiniteTable) {
                            that.currentRow = that.$refs.infiniteTable.data[index];
                            that.$refs.infiniteTable.setCurrentRow(that.$refs.infiniteTable.data[index]);
                        }
                    });
                }
                return;
            }
            if (key === 107 || key === 187) {
                that.addItem(false);
            }
            // if (key == 113) {
            //     that.$refs.searchDlg.showSearchItem();
            // }
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 20px;
    margin-bottom: 20px;
}
.form-main {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-bottom {
    width: 100%;
    display: flex;
    flex-direction: row;
    div {
        width: 50%;
    }
}
.form-applyzone {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-account {
    width: 57.7%;
    float: left;
    margin-left: 30px;
    border: 1px dashed #888888;
    border-radius: 10px;
}
.inventory-title {
    line-height: 1.2;
    flex-direction: column;
    > div:nth-child(1) {
        width: 100%;
        border-bottom: 1px solid @border3Color;
    }
    > div:nth-child(2) {
        width: 100%;
        display: flex;
        > div {
            width: 33.33%;
        }
    }
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
.btn-ctn {
    margin-right: 110px;
    padding: 30px 0;
    text-align: right;
    padding-bottom: 180px;
}
.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}
.div-table-cell-code {
    position: relative;
    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}
.addresscls {
    display: flex;
    flex-direction: row;
}
.addicon {
    height: 30px;
    margin-left: 10px;
    margin-top: 5px;
}
.operate {
    height: 30px;
    // > i {
    //   margin-top: 8.5px;
    //   margin-right: 10px;
    //   cursor: pointer;
    // }
    display: flex;
    align-items: center;
    .el-icon-delete {
        margin-right: 8px;
        cursor: pointer;
    }
    .el-icon-plus {
        margin-right: 8px;
        cursor: pointer;
    }
    .image-sup {
        width: 27px;
        height: 27px;
        margin-right: 2px;
    }
    .image-cus {
        width: 26px;
        height: 26px;
    }
    .pl10 {
        padding-left: 10px;
        cursor: pointer;
    }
}
.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
#ap-image-dialog {
    position: absolute;
    top: 10%;
    left: 10%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .image-item-dialog {
        width: 120px;
        height: 120px;
    }

    .el-dialog__body {
        padding: 0 !important;
        overflow: auto;
    }
}
</style>
<style lang="less">
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 20px;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.goodsMerge {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 12px 0;
                }
                .operate {
                    padding: 0 12px;
                }
                .text-btn {
                    button {
                        padding-left: 0;
                        padding-right: 0;
                    }
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;

            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .special-border {
        height: 100%;
        border-radius: 3px;
        border: 1px solid #ffcc00;
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }
        .info-icon {
            vertical-align: top;
            margin-top: 2px;
            margin-right: 5px;
        }
    }
    .upperLimitWarning {
        .el-input__inner {
            border: 1px solid #e6a23c;
        }
    }
}
</style>
